import { PublisherService } from '../../../../../../services/publisher.service';
import {
    Component,
    OnInit,
    ViewEncapsulation,
    ElementRef
} from '@angular/core';
import { Helpers } from '../../../../../../helpers';
import { Router } from '@angular/router';
import { DatatableComponent } from '../../../datatable.component';

@Component({
    selector: 'app-list-publisher',
    templateUrl: './list-publisher.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListPublisherComponent extends DatatableComponent implements OnInit {
    updateTrigger() {
        this.router.navigate(['/owner/publisher/update/' + this.id]);
    }
    deleteTrigger() {
        this.deleteRow(this.id);
    }
    buildDatatableParams() {
        this.columns = [
            {
                field: 'name',
                title: 'Publisher',
                template: function(row) {
                    return (
                        '<a href="/owner/publisher-detail/' +
                        row.id +
                        '?name=' +
                        row.name +
                        '">' +
                        row.name +
                        '</a>'
                    );
                }
            },
            {
                field: 'Actions',
                width: 80,
                title: 'Actions',
                sortable: false,
                overflow: 'visible',
                textAlign: 'center',
                template: function(row) {
                    return (
                        '\
                    <button data-id="' +
                        row.id +
                        '" id="updatePublisher' +
                        row.id +
                        '" class="update-row m-datatable--on-layout-updated m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit "><i class="la la-edit"></i></button>\
                    <button data-id="' +
                        row.id +
                        '" id="deletePublisher' +
                        row.id +
                        '" class="delete-row m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete "><i class="la la-trash"></i></button>\
                '
                    );
                }
            }
        ];
    }

    datatable: any;

    constructor(
        private publisherService: PublisherService,
        protected el: ElementRef,
        private router: Router
    ) {
        super(el);
    }

    deleteRow(publisherid: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                Helpers.setLoading(true);
                this.publisherService.delete(publisherid).subscribe(() => {
                    Helpers.setLoading(false);
                    this.datatable.load();
                    this.swalService.successDelete();
                });
            }
        });
    }

    ngOnInit() {
        this.datatableUrl = '/publishers/list';
        this.buildDatatable();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/publishers/list-publisher/list-publisher.component.ts